module.exports = __webpack_public_path__ + "media/audio.mp3";